"use strict";

const GMap = () => {
    const init = () => {
        $(function () {
            
            let $mapHolders = $('.js-map-holder');
            let ajaxMap = null;
            let ajaxPin = null;
            let ajaxPoints = null;
            let ajaxActivePin = null;
            
            $mapHolders.each(function () {
                let $mapHolder = $(this);
                let $map = $mapHolder.find('.js-map');
                let lat = parseFloat($map.data('lat'));
                let lng = parseFloat($map.data('lng'));
                let pin = $map.data('pin');
                let activePin = $map.data('active-pin') !== undefined ? $map.data('active-pin') : $map.data('pin');
                let zoom = $map.data('zoom');
                let locations = $map.data('locations');
                let showRegions = $map.data('show-regions');
                let targetRegion = $map.data('target-region');
                let outlineCoordinates = $map.data('outline-coordinates')
                let outlineCoordinatesObj = null
                let outlineAreas = $map.data('outline-areas')
                
                if (typeof outlineCoordinates == 'object') {
                    try {
                        outlineCoordinatesObj = outlineCoordinates.coordinates[0].map((item) => {
                            return {
                                lat: item[1],
                                lng: item[0]
                            }
                        })
                    } catch (error) {
                        outlineCoordinatesObj = null
                    }
                }
                
                let map_obj = new google.maps.Map($map[0], {
                    center: {lat, lng},
                    zoom: parseFloat(zoom),
                    disableDefaultUI: true,
                    styles: [
                        {
                            "featureType": "landscape",
                            "stylers": [{"saturation": -100}, {"lightness": 65}, {"visibility": "on"}]
                        },
                        {
                            "featureType": "poi",
                            "stylers": [{"saturation": -100}, {"lightness": 51}, {"visibility": "simplified"}]
                        },
                        {
                            "featureType": "road.highway",
                            "stylers": [{"saturation": -100}, {"visibility": "simplified"}]
                        },
                        {
                            "featureType": "road.arterial",
                            "stylers": [{"saturation": -100}, {"lightness": 30}, {"visibility": "on"}]
                        },
                        {
                            "featureType": "road.local",
                            "stylers": [{"saturation": -100}, {"lightness": 40}, {"visibility": "on"}]
                        },
                        {
                            "featureType": "transit",
                            "stylers": [{"saturation": -100}, {"visibility": "simplified"}]
                        },
                        {
                            "featureType": "administrative.province",
                            "stylers": [{"visibility": "off"}]
                        },
                        {
                            "featureType": "water",
                            "elementType": "labels",
                            "stylers": [{"visibility": "on"}, {"lightness": -25}, {"saturation": -100}]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [{"hue": "#ffff00"}, {"lightness": -25}, {"saturation": -97}]
                        }
                    ]
                });

                let points = [];
                addLocationsToMap(map_obj, pin, activePin, locations, points, true);

                if($map.hasClass('js-ajax-map')){
                    ajaxMap = map_obj;
                    ajaxPin = pin;
                    ajaxActivePin = activePin;
                    ajaxPoints = points;
                }

                if (outlineCoordinatesObj != null) {
                    const customMap = new google.maps.Polygon({
                        paths: outlineCoordinatesObj,
                        strokeColor: "#003B59",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "#003B59",
                        fillOpacity: 0.35,
                    })

                    customMap.setMap(map_obj);
                }

                if (outlineAreas !== undefined && typeof outlineAreas == 'object') {
                    $.each(outlineAreas.areas, function(k,v){
                        let areaCoordsObj = null;
                        let parsedJson = $.parseJSON(v.outline_coordinates);
                        try {
                            areaCoordsObj = parsedJson.coordinates[0].map((item) => {
                                return {
                                    lat: item[1],
                                    lng: item[0]
                                }
                            })
                        } catch (error) {
                            areaCoordsObj = null
                        }
                        if(areaCoordsObj != null){
                            const newPolygon = new google.maps.Polygon({
                                paths: areaCoordsObj,
                                strokeColor: v.border_colour,
                                strokeOpacity: 1,
                                strokeWeight: 2,
                                fillColor: v.fill_colour,
                                fillOpacity: v.fill_opacity,
                            })
        
                            newPolygon.setMap(map_obj);
                        }
                    });
                }

                if(showRegions !== undefined){
                    const nswCoords = [
                        {lng:150.5835915, lat:-35.0008942},
                        {lng:150.7592010, lat:-34.9002926},
                        {lng:150.7485580, lat:-34.8749468},
                        {lng:150.7557678, lat:-34.8355046},
                        {lng:150.7705307, lat:-34.8098570},
                        {lng:150.7935333, lat:-34.7856113},
                        {lng:150.8347321, lat:-34.7554352},
                        {lng:150.8436584, lat:-34.7294805},
                        {lng:150.8515549, lat:-34.7119847},
                        {lng:150.8543015, lat:-34.7001306},
                        {lng:150.8584213, lat:-34.6956143},
                        {lng:150.8587646, lat:-34.6922270},
                        {lng:150.8560181, lat:-34.6916624},
                        {lng:150.8628845, lat:-34.6902509},
                        {lng:150.8601379, lat:-34.6848872},
                        {lng:150.8563614, lat:-34.6809347},
                        {lng:150.8577347, lat:-34.6769821},
                        {lng:150.8628845, lat:-34.6741586},
                        {lng:150.8659744, lat:-34.6718998},
                        {lng:150.8580780, lat:-34.6687938},
                        {lng:150.8546019, lat:-34.6645582},
                        {lng:150.8555889, lat:-34.6576396},
                        {lng:150.8582067, lat:-34.6541800},
                        {lng:150.8611679, lat:-34.6540388},
                        {lng:150.8634424, lat:-34.6545330},
                        {lng:150.8652878, lat:-34.6501555},
                        {lng:150.8587646, lat:-34.6470487},
                        {lng:150.8625412, lat:-34.6312305},
                        {lng:150.8563614, lat:-34.6210600},
                        {lng:150.8604813, lat:-34.6134314},
                        {lng:150.8735275, lat:-34.6074975},
                        {lng:150.8834839, lat:-34.6074975},
                        {lng:150.8989334, lat:-34.6018458},
                        {lng:150.9023666, lat:-34.5970415},
                        {lng:150.8879471, lat:-34.5936501},
                        {lng:150.8759308, lat:-34.5930849},
                        {lng:150.8752441, lat:-34.5798004},
                        {lng:150.8683777, lat:-34.5690583},
                        {lng:150.8697510, lat:-34.5537907},
                        {lng:150.8742142, lat:-34.5405000},
                        {lng:150.8807373, lat:-34.5229643},
                        {lng:150.8930969, lat:-34.5076883},
                        {lng:150.9178162, lat:-34.4938243},
                        {lng:150.9143829, lat:-34.4776939},
                        {lng:150.9051132, lat:-34.4717503},
                        {lng:150.8965302, lat:-34.4641080},
                        {lng:150.8831406, lat:-34.4638249},
                        {lng:150.8821106, lat:-34.4609942},
                        {lng:150.8893204, lat:-34.4581634},
                        {lng:150.8958435, lat:-34.4547664},
                        {lng:150.9006500, lat:-34.4601450},
                        {lng:150.9003067, lat:-34.4471225},
                        {lng:150.9006500, lat:-34.4380621},
                        {lng:150.9006500, lat:-34.4199385},
                        {lng:150.9068298, lat:-34.4046436},
                        {lng:150.9212494, lat:-34.3808460},
                        {lng:150.9288025, lat:-34.3734787},
                        {lng:150.9233093, lat:-34.3644103},
                        {lng:150.9301758, lat:-34.3383334},
                        {lng:150.9198761, lat:-34.3269931},
                        {lng:150.9095764, lat:-34.3077110},
                        {lng:150.9033966, lat:-34.2850206},
                        {lng:150.8724976, lat:-34.2640265},
                        {lng:150.8203125, lat:-34.2373507},
                        {lng:150.7997131, lat:-34.2129378},
                        {lng:150.7928467, lat:-34.1737489},
                        {lng:150.7928467, lat:-34.1407933},
                        {lng:150.8106995, lat:-34.1220370},
                        {lng:150.8148193, lat:-34.1140785},
                        {lng:150.8457184, lat:-34.0941791},
                        {lng:150.8738708, lat:-34.0719999},
                        {lng:150.8917236, lat:-34.0532283},
                        {lng:150.8882904, lat:-34.0401427},
                        {lng:150.9027100, lat:-34.0105502},
                        {lng:150.9109497, lat:-33.9985965},
                        {lng:150.9075165, lat:-33.9832250},
                        {lng:150.9157562, lat:-33.9513345},
                        {lng:150.9288025, lat:-33.9313968},
                        {lng:150.9418488, lat:-33.9313968},
                        {lng:150.9645081, lat:-33.9308271},
                        {lng:150.9899139, lat:-33.9331059},
                        {lng:151.0105133, lat:-33.9325362},
                        {lng:151.0338593, lat:-33.9256995},
                        {lng:151.0654449, lat:-33.9251297},
                        {lng:151.0922241, lat:-33.9171527},
                        {lng:151.1190033, lat:-33.9108846},
                        {lng:151.1382294, lat:-33.9029063},
                        {lng:151.1421776, lat:-33.8952835},
                        {lng:151.1449242, lat:-33.8840974},
                        {lng:151.1493874, lat:-33.8778268},
                        {lng:151.1521339, lat:-33.8751189},
                        {lng:151.1497307, lat:-33.8707006},
                        {lng:151.1432076, lat:-33.8698454},
                        {lng:151.1492157, lat:-33.8678500},
                        {lng:151.1440659, lat:-33.8647141},
                        {lng:151.1488724, lat:-33.8627186},
                        {lng:151.1555672, lat:-33.8594400},
                        {lng:151.1627769, lat:-33.8581571},
                        {lng:151.1646652, lat:-33.8555911},
                        {lng:151.1596870, lat:-33.8504590},
                        {lng:151.1557388, lat:-33.8460394},
                        {lng:151.1535072, lat:-33.8456116},
                        {lng:151.1514473, lat:-33.8430453},
                        {lng:151.1449242, lat:-33.8444711},
                        {lng:151.1469841, lat:-33.8461819},
                        {lng:151.1499023, lat:-33.8486056},
                        {lng:151.1462975, lat:-33.8518846},
                        {lng:151.1414909, lat:-33.8530251},
                        {lng:151.1438942, lat:-33.8494610},
                        {lng:151.1430359, lat:-33.8464671},
                        {lng:151.1389160, lat:-33.8480353},
                        {lng:151.1351395, lat:-33.8500313},
                        {lng:151.1323929, lat:-33.8488907},
                        {lng:151.1293030, lat:-33.8436156},
                        {lng:151.1263847, lat:-33.8461819},
                        {lng:151.1224365, lat:-33.8500313},
                        {lng:151.1262131, lat:-33.8518846},
                        {lng:151.1263847, lat:-33.8540230},
                        {lng:151.1291313, lat:-33.8604378},
                        {lng:151.1270714, lat:-33.8621484},
                        {lng:151.1195183, lat:-33.8655694},
                        {lng:151.1160851, lat:-33.8627186},
                        {lng:151.1188316, lat:-33.8610080},
                        {lng:151.1207199, lat:-33.8584422},
                        {lng:151.1150551, lat:-33.8545932},
                        {lng:151.1190033, lat:-33.8523123},
                        {lng:151.1159134, lat:-33.8507441},
                        {lng:151.1191750, lat:-33.8477502},
                        {lng:151.1210632, lat:-33.8423324},
                        {lng:151.1138535, lat:-33.8434730},
                        {lng:151.1126518, lat:-33.8401937},
                        {lng:151.1085320, lat:-33.8389105},
                        {lng:151.1056137, lat:-33.8367717},
                        {lng:151.1052704, lat:-33.8417621},
                        {lng:151.1028671, lat:-33.8450414},
                        {lng:151.0999489, lat:-33.8436156},
                        {lng:151.1013222, lat:-33.8406215},
                        {lng:151.1004639, lat:-33.8394808},
                        {lng:151.0966873, lat:-33.8407641},
                        {lng:151.0954857, lat:-33.8394808},
                        {lng:151.0982323, lat:-33.8363440},
                        {lng:151.0973740, lat:-33.8329218},
                        {lng:151.0941124, lat:-33.8352033},
                        {lng:151.0903358, lat:-33.8343477},
                        {lng:151.0917091, lat:-33.8307829},
                        {lng:151.0942841, lat:-33.8279309},
                        {lng:151.0934258, lat:-33.8245084},
                        {lng:151.0860443, lat:-33.8255066},
                        {lng:151.0831261, lat:-33.8380550},
                        {lng:151.0731697, lat:-33.8554485},
                        {lng:151.0611534, lat:-33.8525974},
                        {lng:151.0590935, lat:-33.8450414},
                        {lng:151.0628700, lat:-33.8349181},
                        {lng:151.0611534, lat:-33.8260771},
                        {lng:151.0592651, lat:-33.8236528},
                        {lng:151.0750580, lat:-33.8213710},
                        {lng:151.0966873, lat:-33.8190892},
                        {lng:151.1162567, lat:-33.8202301},
                        {lng:151.1282730, lat:-33.8179482},
                        {lng:151.1464691, lat:-33.8125286},
                        {lng:151.1605453, lat:-33.8139548},
                        {lng:151.1674118, lat:-33.8116728},
                        {lng:151.1790848, lat:-33.8014029},
                        {lng:151.1780548, lat:-33.7894199},
                        {lng:151.1722183, lat:-33.7782912},
                        {lng:151.1619186, lat:-33.7605966},
                        {lng:151.1433792, lat:-33.7423273},
                        {lng:151.1296463, lat:-33.7294794},
                        {lng:151.1203766, lat:-33.7191996},
                        {lng:151.1244965, lat:-33.7026353},
                        {lng:151.1272430, lat:-33.6929237},
                        {lng:151.1368561, lat:-33.6614962},
                        {lng:151.1547089, lat:-33.6432058},
                        {lng:151.1787415, lat:-33.5917433},
                        {lng:151.2014008, lat:-33.5677169},
                        {lng:151.2666321, lat:-33.5425393},
                        {lng:151.2975311, lat:-33.5379607},
                        {lng:151.3201904, lat:-33.5265133},
                        {lng:151.3407898, lat:-33.5087668},
                        {lng:151.3469696, lat:-33.5013237},
                        {lng:151.3723755, lat:-33.4921620},
                        {lng:151.3847351, lat:-33.4847174},
                        {lng:151.4025879, lat:-33.4738357},
                        {lng:151.4451599, lat:-33.4423284},
                        {lng:151.4582062, lat:-33.4199798},
                        {lng:151.4389801, lat:-33.3494584},
                        {lng:151.4781189, lat:-33.2857680},
                        {lng:151.5000916, lat:-33.2679722},
                        {lng:151.5103912, lat:-33.2312212},
                        {lng:151.5371704, lat:-33.2180101},
                        {lng:151.5955353, lat:-33.1921563},
                        {lng:151.6085815, lat:-33.1743416},
                        {lng:151.6264343, lat:-33.1392761},
                        {lng:151.6587067, lat:-33.0616224},
                        {lng:151.6923523, lat:-33.0322687},
                        {lng:151.7720032, lat:-32.9349287},
                        {lng:151.7706299, lat:-32.9107210},
                        {lng:151.7438507, lat:-32.8784339},
                        {lng:151.7108917, lat:-32.8640161},
                        {lng:151.6950989, lat:-32.8253651},
                        {lng:151.7397308, lat:-32.7942013},
                        {lng:151.7623901, lat:-32.7768834},
                        {lng:151.7699432, lat:-32.7618717},
                        {lng:151.7802429, lat:-32.7422373},
                        {lng:151.7980957, lat:-32.7197102},
                        {lng:151.8248749, lat:-32.6913988},
                        {lng:151.8550873, lat:-32.6688588},
                        {lng:151.8846130, lat:-32.6613442},
                        {lng:151.9333649, lat:-32.6526728},
                        {lng:151.9635773, lat:-32.6561414},
                        {lng:151.9731903, lat:-32.6572976},
                        {lng:151.9876099, lat:-32.6677028},
                        {lng:152.0013428, lat:-32.6740609},
                        {lng:152.0411682, lat:-32.6682808},
                        {lng:152.0562744, lat:-32.6520946},
                        {lng:152.0617676, lat:-32.6786846},
                        {lng:152.0782471, lat:-32.6856199},
                        {lng:152.1194458, lat:-32.6682808},
                        {lng:152.1455383, lat:-32.6809964},
                        {lng:152.1977234, lat:-32.6937103},
                        {lng:152.1771240, lat:-32.6636565},
                        {lng:152.0919800, lat:-32.6278099},
                        {lng:152.0164490, lat:-32.5965770},
                        {lng:151.9326782, lat:-32.5861636},
                        {lng:151.7994690, lat:-32.5792206},
                        {lng:151.6209412, lat:-32.5942630},
                        {lng:151.3600159, lat:-32.6335926},
                        {lng:151.1595154, lat:-32.5641758},
                        {lng:151.1691284, lat:-32.6162434},
                        {lng:151.2268066, lat:-32.6520946},
                        {lng:151.2419128, lat:-32.7249093},
                        {lng:151.2748718, lat:-32.8022819},
                        {lng:151.2858582, lat:-32.8899663},
                        {lng:151.3002777, lat:-32.9101446},
                        {lng:151.3455963, lat:-32.9389626},
                        {lng:151.3950348, lat:-32.9574013},
                        {lng:151.4568329, lat:-33.0213305},
                        {lng:151.4520264, lat:-33.0840627},
                        {lng:151.4485931, lat:-33.1277762},
                        {lng:151.4218140, lat:-33.1979023},
                        {lng:151.3950348, lat:-33.2283494},
                        {lng:151.3723755, lat:-33.3150369},
                        {lng:151.3263702, lat:-33.3540469},
                        {lng:151.2824249, lat:-33.3901729},
                        {lng:151.2487793, lat:-33.4302953},
                        {lng:151.2089539, lat:-33.4600885},
                        {lng:151.1210632, lat:-33.4623798},
                        {lng:150.9466553, lat:-33.5093394},
                        {lng:150.9315491, lat:-33.5047591},
                        {lng:150.8573914, lat:-33.5196442},
                        {lng:150.7681274, lat:-33.5139194},
                        {lng:150.6994629, lat:-33.5425393},
                        {lng:150.6816101, lat:-33.5528401},
                        {lng:150.6541443, lat:-33.5682891},
                        {lng:150.6239319, lat:-33.6111883},
                        {lng:150.5971527, lat:-33.6574955},
                        {lng:150.5744934, lat:-33.6969227},
                        {lng:150.5765533, lat:-33.7146305},
                        {lng:150.6095123, lat:-33.7654487},
                        {lng:150.6410980, lat:-33.7808595},
                        {lng:150.6424713, lat:-33.8168073},
                        {lng:150.6665039, lat:-33.8458968},
                        {lng:150.6809235, lat:-33.8926474},
                        {lng:150.6939697, lat:-33.9410814},
                        {lng:150.6946564, lat:-33.9872105},
                        {lng:150.6836700, lat:-34.0202258},
                        {lng:150.6857300, lat:-34.0253477},
                        {lng:150.6719971, lat:-34.0418496},
                        {lng:150.6678772, lat:-34.0577794},
                        {lng:150.6706238, lat:-34.0640367},
                        {lng:150.6623840, lat:-34.0776874},
                        {lng:150.6596375, lat:-34.0924732},
                        {lng:150.6479645, lat:-34.1146470},
                        {lng:150.6328583, lat:-34.1316999},
                        {lng:150.6136322, lat:-34.1487493},
                        {lng:150.5950928, lat:-34.1589773},
                        {lng:150.5854797, lat:-34.1743169},
                        {lng:150.5703735, lat:-34.1941975},
                        {lng:150.5587006, lat:-34.2100986},
                        {lng:150.5532074, lat:-34.2174803},
                        {lng:150.5559540, lat:-34.2282677},
                        {lng:150.5655670, lat:-34.2362154},
                        {lng:150.5683136, lat:-34.2458652},
                        {lng:150.5696869, lat:-34.2662964},
                        {lng:150.5676270, lat:-34.2821839},
                        {lng:150.5662537, lat:-34.3037407},
                        {lng:150.5648804, lat:-34.3235907},
                        {lng:150.5456543, lat:-34.3513729},
                        {lng:150.5229950, lat:-34.3774458},
                        {lng:150.5003357, lat:-34.3984115},
                        {lng:150.4804230, lat:-34.4216377},
                        {lng:150.4730415, lat:-34.4258857},
                        {lng:150.4714966, lat:-34.4287176},
                        {lng:150.4701233, lat:-34.4309122},
                        {lng:150.4670334, lat:-34.4333900},
                        {lng:150.4658318, lat:-34.4355137},
                        {lng:150.4584503, lat:-34.4411767},
                        {lng:150.4498672, lat:-34.4420261},
                        {lng:150.4392242, lat:-34.4434418},
                        {lng:150.4275513, lat:-34.4428755},
                        {lng:150.4193115, lat:-34.4573142},
                        {lng:150.4096985, lat:-34.4706182},
                        {lng:150.3932190, lat:-34.4901457},
                        {lng:150.3853226, lat:-34.4986345},
                        {lng:150.3774261, lat:-34.5170240},
                        {lng:150.3636932, lat:-34.5331468},
                        {lng:150.3575134, lat:-34.5427624},
                        {lng:150.3492737, lat:-34.5523769},
                        {lng:150.3403473, lat:-34.5569010},
                        {lng:150.3630066, lat:-34.5761256},
                        {lng:150.4069519, lat:-34.6032587},
                        {lng:150.4296112, lat:-34.6162569},
                        {lng:150.4474640, lat:-34.6289705},
                        {lng:150.4570770, lat:-34.6402698},
                        {lng:150.4690933, lat:-34.6524149},
                        {lng:150.4800797, lat:-34.6879926},
                        {lng:150.4941559, lat:-34.7306091},
                        {lng:150.4941559, lat:-34.7452800},
                        {lng:150.5030823, lat:-34.7715117},
                        {lng:150.4896927, lat:-34.7977350},
                        {lng:150.4893494, lat:-34.8056286},
                        {lng:150.4907227, lat:-34.8104208},
                        {lng:150.4996490, lat:-34.8295866},
                        {lng:150.5089188, lat:-34.8617076},
                        {lng:150.5175018, lat:-34.8788900},
                        {lng:150.5274582, lat:-34.9005741},
                        {lng:150.5350113, lat:-34.9225340},
                        {lng:150.5466843, lat:-34.9439252},
                        {lng:150.5569839, lat:-34.9616531},
                        {lng:150.5714035, lat:-34.9869721},
                        {lng:150.5835915, lat:-35.0008942},
                    ];

                    if (targetRegion == 'none' || targetRegion == 'nsw') {
                        const nsw = new google.maps.Polygon({
                            paths: nswCoords,
                            strokeColor: "#003B59",
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: "#003B59",
                            fillOpacity: 0.35,
                        });
                        nsw.setMap(map_obj);
                        if(targetRegion != 'nsw'){
                            nsw.addListener('click', function () {
                                location.href="/nsw";
                            });
                        }
                    }

                    const qldCoords = [
                        {lng:153.5507584, lat:-28.1650162},
                        {lng:153.5520619, lat:-28.1644440},
                        {lng:153.5520029, lat:-28.1642595},
                        {lng:153.5514021, lat:-28.1632380},
                        {lng:153.5507584, lat:-28.1625191},
                        {lng:153.5502005, lat:-28.1620273},
                        {lng:153.5492134, lat:-28.1620651},
                        {lng:153.5450935, lat:-28.1631245},
                        {lng:153.5408020, lat:-28.1646379},
                        {lng:153.5359955, lat:-28.1644865},
                        {lng:153.5287857, lat:-28.1644865},
                        {lng:153.5229492, lat:-28.1626705},
                        {lng:153.5140228, lat:-28.1582816},
                        {lng:153.5080147, lat:-28.1534384},
                        {lng:153.5021782, lat:-28.1475355},
                        {lng:153.4977150, lat:-28.1399673},
                        {lng:153.4894753, lat:-28.1284625},
                        {lng:153.4887886, lat:-28.1251319},
                        {lng:153.4856987, lat:-28.1237694},
                        {lng:153.4838104, lat:-28.1257375},
                        {lng:153.4783173, lat:-28.1242236},
                        {lng:153.4680176, lat:-28.1066606},
                        {lng:153.4608078, lat:-28.0915177},
                        {lng:153.4572029, lat:-28.0890947},
                        {lng:153.4541130, lat:-28.0866716},
                        {lng:153.4508514, lat:-28.0804621},
                        {lng:153.4436417, lat:-28.0578930},
                        {lng:153.4402084, lat:-28.0453189},
                        {lng:153.4364319, lat:-28.0269853},
                        {lng:153.4336853, lat:-28.0086486},
                        {lng:153.4312820, lat:-27.9737851},
                        {lng:153.4311104, lat:-27.9348156},
                        {lng:153.4086227, lat:-27.9364839},
                        {lng:153.4072495, lat:-27.9249573},
                        {lng:153.4084511, lat:-27.9166150},
                        {lng:153.4091377, lat:-27.9078169},
                        {lng:153.4046745, lat:-27.8990181},
                        {lng:153.4041595, lat:-27.8943149},
                        {lng:153.4074211, lat:-27.8849081},
                        {lng:153.4122276, lat:-27.8783836},
                        {lng:153.4125710, lat:-27.8723138},
                        {lng:153.4101677, lat:-27.8657885},
                        {lng:153.4051895, lat:-27.8662438},
                        {lng:153.4019279, lat:-27.8679131},
                        {lng:153.3986664, lat:-27.8700376},
                        {lng:153.3972931, lat:-27.8724656},
                        {lng:153.3928299, lat:-27.8755005},
                        {lng:153.3873367, lat:-27.8766385},
                        {lng:153.3835602, lat:-27.8747418},
                        {lng:153.3822727, lat:-27.8712516},
                        {lng:153.3817577, lat:-27.8626016},
                        {lng:153.3811569, lat:-27.8589593},
                        {lng:153.3801270, lat:-27.8570622},
                        {lng:153.3784103, lat:-27.8551650},
                        {lng:153.3747196, lat:-27.8544062},
                        {lng:153.3718872, lat:-27.8539509},
                        {lng:153.3703423, lat:-27.8538750},
                        {lng:153.3687115, lat:-27.8530402},
                        {lng:153.3668232, lat:-27.8523572},
                        {lng:153.3649349, lat:-27.8510671},
                        {lng:153.3667374, lat:-27.8490181},
                        {lng:153.3731747, lat:-27.8484869},
                        {lng:153.3743763, lat:-27.8462861},
                        {lng:153.3766079, lat:-27.8426432},
                        {lng:153.3790970, lat:-27.8402145},
                        {lng:153.3792686, lat:-27.8361920},
                        {lng:153.3817577, lat:-27.8339150},
                        {lng:153.3828735, lat:-27.8317898},
                        {lng:153.3854485, lat:-27.8306512},
                        {lng:153.3854485, lat:-27.8287536},
                        {lng:153.3847618, lat:-27.8265524},
                        {lng:153.3837318, lat:-27.8241993},
                        {lng:153.3827019, lat:-27.8220739},
                        {lng:153.3817577, lat:-27.8207834},
                        {lng:153.3781528, lat:-27.8193411},
                        {lng:153.3761787, lat:-27.8184302},
                        {lng:153.3728313, lat:-27.8151659},
                        {lng:153.3718014, lat:-27.8115979},
                        {lng:153.3726597, lat:-27.8078780},
                        {lng:153.3751488, lat:-27.8063596},
                        {lng:153.3773804, lat:-27.8037024},
                        {lng:153.3795261, lat:-27.8030950},
                        {lng:153.3817577, lat:-27.8010451},
                        {lng:153.3833885, lat:-27.7999822},
                        {lng:153.3839035, lat:-27.7986914},
                        {lng:153.3836460, lat:-27.7961100},
                        {lng:153.3847618, lat:-27.7958063},
                        {lng:153.3857918, lat:-27.7963377},
                        {lng:153.3879375, lat:-27.7963377},
                        {lng:153.3911133, lat:-27.7942118},
                        {lng:153.3894825, lat:-27.7923895},
                        {lng:153.3870792, lat:-27.7904912},
                        {lng:153.3848476, lat:-27.7887448},
                        {lng:153.3827019, lat:-27.7874539},
                        {lng:153.3812428, lat:-27.7873780},
                        {lng:153.3783245, lat:-27.7869224},
                        {lng:153.3757496, lat:-27.7861631},
                        {lng:153.3697414, lat:-27.7817588},
                        {lng:153.3607292, lat:-27.7745446},
                        {lng:153.3606434, lat:-27.7696842},
                        {lng:153.3609867, lat:-27.7658109},
                        {lng:153.3603001, lat:-27.7644438},
                        {lng:153.3575535, lat:-27.7630008},
                        {lng:153.3566952, lat:-27.7618615},
                        {lng:153.3554077, lat:-27.7598108},
                        {lng:153.3538628, lat:-27.7585956},
                        {lng:153.3533478, lat:-27.7558613},
                        {lng:153.3547211, lat:-27.7534307},
                        {lng:153.3545494, lat:-27.7475059},
                        {lng:153.3569527, lat:-27.7421885},
                        {lng:153.3593559, lat:-27.7385421},
                        {lng:153.3612442, lat:-27.7356553},
                        {lng:153.3578110, lat:-27.7306413},
                        {lng:153.3540344, lat:-27.7236516},
                        {lng:153.3564377, lat:-27.7180291},
                        {lng:153.3512878, lat:-27.7078471},
                        {lng:153.3387566, lat:-27.6988801},
                        {lng:153.3257103, lat:-27.6994881},
                        {lng:153.3221912, lat:-27.6930283},
                        {lng:153.3209038, lat:-27.6897603},
                        {lng:153.3187580, lat:-27.6858842},
                        {lng:153.3180714, lat:-27.6810959},
                        {lng:153.3203888, lat:-27.6778275},
                        {lng:153.3219337, lat:-27.6725828},
                        {lng:153.3179855, lat:-27.6666536},
                        {lng:153.3131790, lat:-27.6631567},
                        {lng:153.3107758, lat:-27.6587475},
                        {lng:153.3116341, lat:-27.6537299},
                        {lng:153.3114624, lat:-27.6485600},
                        {lng:153.3155823, lat:-27.6443023},
                        {lng:153.3157539, lat:-27.6383715},
                        {lng:153.3136940, lat:-27.6193607},
                        {lng:153.3130074, lat:-27.6152539},
                        {lng:153.3100891, lat:-27.6138849},
                        {lng:153.3078575, lat:-27.6099301},
                        {lng:153.3068275, lat:-27.6071920},
                        {lng:153.3054543, lat:-27.6035411},
                        {lng:153.3032227, lat:-27.5998901},
                        {lng:153.3030510, lat:-27.5971518},
                        {lng:153.3069992, lat:-27.5944134},
                        {lng:153.3097458, lat:-27.5916750},
                        {lng:153.3140373, lat:-27.5900014},
                        {lng:153.3162689, lat:-27.5865021},
                        {lng:153.3190155, lat:-27.5857414},
                        {lng:153.3212471, lat:-27.5830027},
                        {lng:153.3191872, lat:-27.5793511},
                        {lng:153.3150673, lat:-27.5778295},
                        {lng:153.3121490, lat:-27.5801118},
                        {lng:153.3094025, lat:-27.5767644},
                        {lng:153.3076859, lat:-27.5737212},
                        {lng:153.3106041, lat:-27.5685475},
                        {lng:153.3095741, lat:-27.5644388},
                        {lng:153.3059692, lat:-27.5630692},
                        {lng:153.2999611, lat:-27.5626127},
                        {lng:153.2924080, lat:-27.5630692},
                        {lng:153.2920647, lat:-27.5610909},
                        {lng:153.2912064, lat:-27.5577429},
                        {lng:153.2894897, lat:-27.5554600},
                        {lng:153.2855415, lat:-27.5533294},
                        {lng:153.2819366, lat:-27.5519596},
                        {lng:153.2836533, lat:-27.5499811},
                        {lng:153.2851982, lat:-27.5469371},
                        {lng:153.2831383, lat:-27.5431321},
                        {lng:153.2803917, lat:-27.5411534},
                        {lng:153.2827950, lat:-27.5390224},
                        {lng:153.2853699, lat:-27.5362826},
                        {lng:153.2869148, lat:-27.5300416},
                        {lng:153.2896614, lat:-27.5213645},
                        {lng:153.2915497, lat:-27.5166451},
                        {lng:153.2920647, lat:-27.5082714},
                        {lng:153.2870865, lat:-27.5082714},
                        {lng:153.2869148, lat:-27.5132957},
                        {lng:153.2644272, lat:-27.5134479},
                        {lng:153.2633972, lat:-27.5116210},
                        {lng:153.2627106, lat:-27.4935018},
                        {lng:153.2542992, lat:-27.4921313},
                        {lng:153.2522392, lat:-27.4892380},
                        {lng:153.2477760, lat:-27.4869538},
                        {lng:153.2433128, lat:-27.4848218},
                        {lng:153.2439995, lat:-27.4784256},
                        {lng:153.2445145, lat:-27.4694398},
                        {lng:153.2422829, lat:-27.4624334},
                        {lng:153.2366180, lat:-27.4580161},
                        {lng:153.2324982, lat:-27.4522277},
                        {lng:153.2304382, lat:-27.4558836},
                        {lng:153.2319832, lat:-27.4615195},
                        {lng:153.2345581, lat:-27.4656320},
                        {lng:153.2350731, lat:-27.4700490},
                        {lng:153.2350731, lat:-27.4773595},
                        {lng:153.2323265, lat:-27.4808623},
                        {lng:153.2247734, lat:-27.4814714},
                        {lng:153.2137871, lat:-27.4799485},
                        {lng:153.2062340, lat:-27.4785779},
                        {lng:153.2034874, lat:-27.4752273},
                        {lng:153.1991959, lat:-27.4735520},
                        {lng:153.1955910, lat:-27.4733997},
                        {lng:153.1962776, lat:-27.4703536},
                        {lng:153.1942177, lat:-27.4631950},
                        {lng:153.1962776, lat:-27.4609102},
                        {lng:153.1955910, lat:-27.4551219},
                        {lng:153.1937027, lat:-27.4494857},
                        {lng:153.1883812, lat:-27.4505520},
                        {lng:153.1899261, lat:-27.4482670},
                        {lng:153.1885529, lat:-27.4458296},
                        {lng:153.1779099, lat:-27.4398881},
                        {lng:153.1705284, lat:-27.4203858},
                        {lng:153.1693268, lat:-27.4106333},
                        {lng:153.1657219, lat:-27.4011848},
                        {lng:153.1609154, lat:-27.4019468},
                        {lng:153.1578255, lat:-27.3958506},
                        {lng:153.1562805, lat:-27.3888395},
                        {lng:153.1609154, lat:-27.3818280},
                        {lng:153.1624603, lat:-27.3767978},
                        {lng:153.1595421, lat:-27.3711575},
                        {lng:153.1598854, lat:-27.3662792},
                        {lng:153.1552505, lat:-27.3612483},
                        {lng:153.1476974, lat:-27.3594188},
                        {lng:153.1432343, lat:-27.3595712},
                        {lng:153.1384277, lat:-27.3592663},
                        {lng:153.1269264, lat:-27.3534727},
                        {lng:153.0986023, lat:-27.3412746},
                        {lng:153.0955124, lat:-27.3397497},
                        {lng:153.0884743, lat:-27.3334976},
                        {lng:153.0901909, lat:-27.3309052},
                        {lng:153.0901909, lat:-27.3252626},
                        {lng:153.0824661, lat:-27.3197722},
                        {lng:153.0773163, lat:-27.3188571},
                        {lng:153.0680466, lat:-27.3039096},
                        {lng:153.0663300, lat:-27.2833153},
                        {lng:153.0685616, lat:-27.2733982},
                        {lng:153.0680466, lat:-27.2672950},
                        {lng:153.0706215, lat:-27.2627173},
                        {lng:153.0759430, lat:-27.2633276},
                        {lng:153.0816078, lat:-27.2625647},
                        {lng:153.0843544, lat:-27.2607336},
                        {lng:153.0869293, lat:-27.2604284},
                        {lng:153.0893326, lat:-27.2593602},
                        {lng:153.0924225, lat:-27.2573764},
                        {lng:153.0955124, lat:-27.2584446},
                        {lng:153.0994606, lat:-27.2604284},
                        {lng:153.1032372, lat:-27.2639380},
                        {lng:153.1073570, lat:-27.2636328},
                        {lng:153.1092453, lat:-27.2595128},
                        {lng:153.1102753, lat:-27.2544770},
                        {lng:153.1178284, lat:-27.2334157},
                        {lng:153.1162834, lat:-27.2250205},
                        {lng:153.1180000, lat:-27.2173881},
                        {lng:153.1185150, lat:-27.2115871},
                        {lng:153.1176567, lat:-27.2047170},
                        {lng:153.1169701, lat:-27.2031903},
                        {lng:153.1167984, lat:-27.2009002},
                        {lng:153.1169701, lat:-27.1978466},
                        {lng:153.1166267, lat:-27.1966251},
                        {lng:153.1161118, lat:-27.1928080},
                        {lng:153.1142235, lat:-27.1906703},
                        {lng:153.1119919, lat:-27.1905176},
                        {lng:153.1107903, lat:-27.1923499},
                        {lng:153.1089020, lat:-27.1905176},
                        {lng:153.1056404, lat:-27.1905176},
                        {lng:153.1039238, lat:-27.1920445},
                        {lng:153.1035805, lat:-27.1941822},
                        {lng:153.1040955, lat:-27.1973885},
                        {lng:153.1025505, lat:-27.1996787},
                        {lng:153.0998039, lat:-27.2012055},
                        {lng:153.0958557, lat:-27.2033430},
                        {lng:153.0913925, lat:-27.2039537},
                        {lng:153.0877876, lat:-27.2057857},
                        {lng:153.0852127, lat:-27.2033430},
                        {lng:153.0805779, lat:-27.2016635},
                        {lng:153.0764580, lat:-27.2013582},
                        {lng:153.0726814, lat:-27.2007475},
                        {lng:153.0685616, lat:-27.1990680},
                        {lng:153.0582619, lat:-27.1975412},
                        {lng:153.0517387, lat:-27.1955563},
                        {lng:153.0465889, lat:-27.1943348},
                        {lng:153.0393791, lat:-27.1964724},
                        {lng:153.0307961, lat:-27.1862422},
                        {lng:153.0306244, lat:-27.1810504},
                        {lng:153.0313110, lat:-27.1763164},
                        {lng:153.0330276, lat:-27.1731094},
                        {lng:153.0342293, lat:-27.1700551},
                        {lng:153.0369759, lat:-27.1677643},
                        {lng:153.0433273, lat:-27.1578369},
                        {lng:153.0419540, lat:-27.1549349},
                        {lng:153.0438423, lat:-27.1498943},
                        {lng:153.0477905, lat:-27.1469921},
                        {lng:153.0508804, lat:-27.1407291},
                        {lng:153.0558586, lat:-27.1295771},
                        {lng:153.0596352, lat:-27.1227020},
                        {lng:153.0635834, lat:-27.1165905},
                        {lng:153.0658150, lat:-27.1120066},
                        {lng:153.0752563, lat:-27.1066586},
                        {lng:153.0886459, lat:-27.0987124},
                        {lng:153.0996323, lat:-27.0933636},
                        {lng:153.1030655, lat:-27.0909184},
                        {lng:153.1181717, lat:-27.0863335},
                        {lng:153.1207466, lat:-27.0880147},
                        {lng:153.1267548, lat:-27.0880147},
                        {lng:153.1324196, lat:-27.0869448},
                        {lng:153.1358528, lat:-27.0854165},
                        {lng:153.1399727, lat:-27.0825126},
                        {lng:153.1440926, lat:-27.0802200},
                        {lng:153.1449509, lat:-27.0753289},
                        {lng:153.1420326, lat:-27.0738004},
                        {lng:153.1367111, lat:-27.0716605},
                        {lng:153.1312180, lat:-27.0669219},
                        {lng:153.1119919, lat:-27.0560683},
                        {lng:153.1099319, lat:-27.0514820},
                        {lng:153.1087303, lat:-27.0470483},
                        {lng:153.1068420, lat:-27.0456723},
                        {lng:153.1037521, lat:-27.0384863},
                        {lng:153.1022072, lat:-27.0348167},
                        {lng:153.0967140, lat:-27.0305353},
                        {lng:153.0910492, lat:-27.0274770},
                        {lng:153.0867577, lat:-27.0201369},
                        {lng:153.0828094, lat:-27.0161608},
                        {lng:153.0759430, lat:-27.0120317},
                        {lng:153.0733681, lat:-27.0095847},
                        {lng:153.0728531, lat:-27.0069847},
                        {lng:153.0721664, lat:-27.0031611},
                        {lng:153.0757713, lat:-27.0014787},
                        {lng:153.0742264, lat:-27.0004080},
                        {lng:153.0719948, lat:-27.0017846},
                        {lng:153.0695915, lat:-26.9993373},
                        {lng:153.0656433, lat:-26.9979608},
                        {lng:153.0639267, lat:-26.9945957},
                        {lng:153.0675316, lat:-26.9945957},
                        {lng:153.0695915, lat:-26.9909247},
                        {lng:153.0690765, lat:-26.9791458},
                        {lng:153.0695915, lat:-26.9756272},
                        {lng:153.0689907, lat:-26.9729500},
                        {lng:153.0677891, lat:-26.9705786},
                        {lng:153.0672741, lat:-26.9677483},
                        {lng:153.0661583, lat:-26.9655298},
                        {lng:153.0623817, lat:-26.9630053},
                        {lng:153.0614376, lat:-26.9389815},
                        {lng:153.0657291, lat:-26.9293399},
                        {lng:153.0672741, lat:-26.9260493},
                        {lng:153.0689049, lat:-26.9232944},
                        {lng:153.0692482, lat:-26.9194679},
                        {lng:153.0699348, lat:-26.9144168},
                        {lng:153.0695915, lat:-26.9108196},
                        {lng:153.0716515, lat:-26.9063039},
                        {lng:153.0742264, lat:-26.9043139},
                        {lng:153.0775738, lat:-26.8998744},
                        {lng:153.0821228, lat:-26.8957410},
                        {lng:153.0855560, lat:-26.8969657},
                        {lng:153.0927658, lat:-26.8957410},
                        {lng:153.1034088, lat:-26.8895406},
                        {lng:153.1071854, lat:-26.8874737},
                        {lng:153.1077862, lat:-26.8843350},
                        {lng:153.1080437, lat:-26.8804307},
                        {lng:153.1079149, lat:-26.8772344},
                        {lng:153.1080222, lat:-26.8762774},
                        {lng:153.1083441, lat:-26.8761625},
                        {lng:153.1090093, lat:-26.8754735},
                        {lng:153.1095672, lat:-26.8741337},
                        {lng:153.1114769, lat:-26.8718560},
                        {lng:153.1130219, lat:-26.8679512},
                        {lng:153.1115627, lat:-26.8628978},
                        {lng:153.1104469, lat:-26.8592990},
                        {lng:153.1104469, lat:-26.8534794},
                        {lng:153.1115627, lat:-26.8472767},
                        {lng:153.1132793, lat:-26.8447495},
                        {lng:153.1157684, lat:-26.8409970},
                        {lng:153.1187725, lat:-26.8350233},
                        {lng:153.1218624, lat:-26.8292025},
                        {lng:153.1216908, lat:-26.8279771},
                        {lng:153.1216908, lat:-26.8242240},
                        {lng:153.1216049, lat:-26.8213899},
                        {lng:153.1219482, lat:-26.8177898},
                        {lng:153.1228065, lat:-26.8112787},
                        {lng:153.1238365, lat:-26.8091338},
                        {lng:153.1247807, lat:-26.8066058},
                        {lng:153.1264973, lat:-26.8061461},
                        {lng:153.1285572, lat:-26.8064526},
                        {lng:153.1306171, lat:-26.8067590},
                        {lng:153.1320763, lat:-26.8074484},
                        {lng:153.1338787, lat:-26.8078315},
                        {lng:153.1354237, lat:-26.8076783},
                        {lng:153.1388569, lat:-26.8068356},
                        {lng:153.1399727, lat:-26.8054567},
                        {lng:153.1416893, lat:-26.8046140},
                        {lng:153.1445217, lat:-26.8035415},
                        {lng:153.1461525, lat:-26.8034649},
                        {lng:153.1482983, lat:-26.8038479},
                        {lng:153.1503582, lat:-26.8035415},
                        {lng:153.1514740, lat:-26.8024689},
                        {lng:153.1507874, lat:-26.7994045},
                        {lng:153.1493282, lat:-26.7983319},
                        {lng:153.1485558, lat:-26.7970295},
                        {lng:153.1485558, lat:-26.7941948},
                        {lng:153.1489849, lat:-26.7921262},
                        {lng:153.1472683, lat:-26.7906704},
                        {lng:153.1446075, lat:-26.7901341},
                        {lng:153.1421185, lat:-26.7886784},
                        {lng:153.1409168, lat:-26.7850006},
                        {lng:153.1383419, lat:-26.7786409},
                        {lng:153.1373978, lat:-26.7745030},
                        {lng:153.1372261, lat:-26.7696753},
                        {lng:153.1372261, lat:-26.7656904},
                        {lng:153.1366253, lat:-26.7638511},
                        {lng:153.1373119, lat:-26.7582566},
                        {lng:153.1369686, lat:-26.7547311},
                        {lng:153.1356812, lat:-26.7449972},
                        {lng:153.1352520, lat:-26.7233803},
                        {lng:153.1364536, lat:-26.6932861},
                        {lng:153.1367326, lat:-26.6896820},
                        {lng:153.1368184, lat:-26.6874389},
                        {lng:153.1371403, lat:-26.6849082},
                        {lng:153.1373978, lat:-26.6832402},
                        {lng:153.1375265, lat:-26.6824541},
                        {lng:153.1377840, lat:-26.6817831},
                        {lng:153.1384277, lat:-26.6811695},
                        {lng:153.1387496, lat:-26.6804601},
                        {lng:153.1390071, lat:-26.6797699},
                        {lng:153.1387711, lat:-26.6794440},
                        {lng:153.1366253, lat:-26.6796740},
                        {lng:153.1349087, lat:-26.6794440},
                        {lng:153.1330204, lat:-26.6792139},
                        {lng:153.1330204, lat:-26.6802109},
                        {lng:153.1342220, lat:-26.6812079},
                        {lng:153.1337929, lat:-26.6824349},
                        {lng:153.1303596, lat:-26.6841988},
                        {lng:153.1217766, lat:-26.6810545},
                        {lng:153.1196308, lat:-26.6785237},
                        {lng:153.1173134, lat:-26.6774499},
                        {lng:153.1150818, lat:-26.6744588},
                        {lng:153.1136227, lat:-26.6723113},
                        {lng:153.1116486, lat:-26.6723113},
                        {lng:153.1075287, lat:-26.6687832},
                        {lng:153.1062412, lat:-26.6632607},
                        {lng:153.1036663, lat:-26.6530587},
                        {lng:153.1028080, lat:-26.6456943},
                        {lng:153.1019497, lat:-26.6356441},
                        {lng:153.1022072, lat:-26.6156179},
                        {lng:153.0986023, lat:-26.6033396},
                        {lng:153.0975723, lat:-26.5902349},
                        {lng:153.0978298, lat:-26.5777236},
                        {lng:153.0984735, lat:-26.5702008},
                        {lng:153.0994606, lat:-26.5605854},
                        {lng:153.0872726, lat:-26.5573610},
                        {lng:153.0053902, lat:-26.5744036},
                        {lng:152.9717445, lat:-26.5754783},
                        {lng:152.9526901, lat:-26.5836148},
                        {lng:152.9513168, lat:-26.6222937},
                        {lng:152.9526901, lat:-26.6431626},
                        {lng:152.9506302, lat:-26.6784470},
                        {lng:152.9485703, lat:-26.7085067},
                        {lng:152.9492569, lat:-26.7419312},
                        {lng:152.9461670, lat:-26.7701351},
                        {lng:152.9550934, lat:-26.8004771},
                        {lng:152.9420471, lat:-26.8525605},
                        {lng:152.9389572, lat:-26.8853302},
                        {lng:152.9389572, lat:-26.9202332},
                        {lng:152.9513168, lat:-26.9578796},
                        {lng:152.9420471, lat:-26.9982667},
                        {lng:152.9406738, lat:-27.0184548},
                        {lng:152.9456520, lat:-27.0674569},
                        {lng:152.9409313, lat:-27.0654697},
                        {lng:152.9346657, lat:-27.0629475},
                        {lng:152.9295158, lat:-27.0673805},
                        {lng:152.9243660, lat:-27.0724248},
                        {lng:152.9199028, lat:-27.0767046},
                        {lng:152.9174995, lat:-27.0812899},
                        {lng:152.9106331, lat:-27.0849580},
                        {lng:152.9085732, lat:-27.0878618},
                        {lng:152.8989601, lat:-27.0953503},
                        {lng:152.8890038, lat:-27.1000877},
                        {lng:152.8845406, lat:-27.1065057},
                        {lng:152.8811073, lat:-27.1142986},
                        {lng:152.8891754, lat:-27.1220909},
                        {lng:152.9142380, lat:-27.1211742},
                        {lng:152.9317474, lat:-27.1193407},
                        {lng:152.9399872, lat:-27.1199519},
                        {lng:152.9447937, lat:-27.1254521},
                        {lng:152.9437637, lat:-27.1355352},
                        {lng:152.9437637, lat:-27.1590588},
                        {lng:152.9506302, lat:-27.2607336},
                        {lng:152.9521751, lat:-27.2698889},
                        {lng:152.9492569, lat:-27.2767549},
                        {lng:152.9399872, lat:-27.2787383},
                        {lng:152.9302883, lat:-27.2843833},
                        {lng:152.9265976, lat:-27.2834679},
                        {lng:152.9230785, lat:-27.2853749},
                        {lng:152.8678894, lat:-27.2875871},
                        {lng:152.8349304, lat:-27.2897229},
                        {lng:152.8222275, lat:-27.2894177},
                        {lng:152.8174210, lat:-27.2918586},
                        {lng:152.8167343, lat:-27.3019266},
                        {lng:152.8194809, lat:-27.3147391},
                        {lng:152.8256607, lat:-27.3324301},
                        {lng:152.8273773, lat:-27.3434094},
                        {lng:152.8345871, lat:-27.3464589},
                        {lng:152.8390503, lat:-27.3617056},
                        {lng:152.8194809, lat:-27.3678037},
                        {lng:152.8102112, lat:-27.3763405},
                        {lng:152.8205109, lat:-27.3888395},
                        {lng:152.8397369, lat:-27.4059092},
                        {lng:152.8479767, lat:-27.4107857},
                        {lng:152.8617096, lat:-27.4086522},
                        {lng:152.8733826, lat:-27.4037756},
                        {lng:152.8819656, lat:-27.4004228},
                        {lng:152.8898621, lat:-27.4004228},
                        {lng:152.8956985, lat:-27.4043852},
                        {lng:152.9053116, lat:-27.4104809},
                        {lng:152.9056549, lat:-27.4168811},
                        {lng:152.9049683, lat:-27.4263283},
                        {lng:152.9066849, lat:-27.4330322},
                        {lng:152.9180145, lat:-27.4324228},
                        {lng:152.9252243, lat:-27.4400405},
                        {lng:152.9276276, lat:-27.4537510},
                        {lng:152.9231644, lat:-27.4717244},
                        {lng:152.9265976, lat:-27.4988313},
                        {lng:152.9193878, lat:-27.5283671},
                        {lng:152.9056549, lat:-27.5241047},
                        {lng:152.8970718, lat:-27.5213645},
                        {lng:152.8778458, lat:-27.5180152},
                        {lng:152.8596497, lat:-27.5161883},
                        {lng:152.8349304, lat:-27.5094894},
                        {lng:152.8170776, lat:-27.5043127},
                        {lng:152.7902985, lat:-27.4991358},
                        {lng:152.7789688, lat:-27.4960904},
                        {lng:152.7648926, lat:-27.4942631},
                        {lng:152.7532196, lat:-27.5009630},
                        {lng:152.7515030, lat:-27.5241047},
                        {lng:152.7425766, lat:-27.5723517},
                        {lng:152.6711655, lat:-27.5714387},
                        {lng:152.6651573, lat:-27.5718952},
                        {lng:152.6636124, lat:-27.5779817},
                        {lng:152.6639557, lat:-27.5918271},
                        {lng:152.6625824, lat:-27.5944134},
                        {lng:152.6594925, lat:-27.6126681},
                        {lng:152.6584625, lat:-27.6202733},
                        {lng:152.6600075, lat:-27.6243799},
                        {lng:152.6617241, lat:-27.6281821},
                        {lng:152.6668739, lat:-27.6303113},
                        {lng:152.6732254, lat:-27.6303113},
                        {lng:152.6766586, lat:-27.6322884},
                        {lng:152.6775169, lat:-27.6363946},
                        {lng:152.6790619, lat:-27.6386757},
                        {lng:152.6806068, lat:-27.6418692},
                        {lng:152.6828384, lat:-27.6458229},
                        {lng:152.6842117, lat:-27.6519053},
                        {lng:152.6891899, lat:-27.6563148},
                        {lng:152.7006912, lat:-27.6555545},
                        {lng:152.7060127, lat:-27.6575311},
                        {lng:152.7233505, lat:-27.6636129},
                        {lng:152.7396584, lat:-27.6669576},
                        {lng:152.7413750, lat:-27.6680219},
                        {lng:152.7417183, lat:-27.6713665},
                        {lng:152.7437782, lat:-27.6782076},
                        {lng:152.7490997, lat:-27.6813999},
                        {lng:152.7695274, lat:-27.6836801},
                        {lng:152.7865219, lat:-27.6914324},
                        {lng:152.7909851, lat:-27.6929523},
                        {lng:152.7969933, lat:-27.6926484},
                        {lng:152.8071213, lat:-27.6874803},
                        {lng:152.8098679, lat:-27.6876323},
                        {lng:152.8205109, lat:-27.6899124},
                        {lng:152.8268623, lat:-27.6879363},
                        {lng:152.8345871, lat:-27.6833761},
                        {lng:152.8380203, lat:-27.6801838},
                        {lng:152.8424835, lat:-27.6779035},
                        {lng:152.8471184, lat:-27.6777515},
                        {lng:152.8527832, lat:-27.6782076},
                        {lng:152.8570747, lat:-27.6798798},
                        {lng:152.8625679, lat:-27.6801838},
                        {lng:152.8685760, lat:-27.6795757},
                        {lng:152.8732109, lat:-27.6780556},
                        {lng:152.8788757, lat:-27.6766874},
                        {lng:152.8850555, lat:-27.6763833},
                        {lng:152.8890038, lat:-27.6765354},
                        {lng:152.8917503, lat:-27.6775995},
                        {lng:152.8958702, lat:-27.6771434},
                        {lng:152.9022217, lat:-27.6766874},
                        {lng:152.9277992, lat:-27.6903684},
                        {lng:152.9592133, lat:-27.6956883},
                        {lng:152.9609299, lat:-27.7306413},
                        {lng:152.9530334, lat:-27.7768228},
                        {lng:152.9657364, lat:-27.8891565},
                        {lng:152.9717445, lat:-27.9245023},
                        {lng:152.9731178, lat:-27.9296591},
                        {lng:152.9741478, lat:-27.9346640},
                        {lng:152.9756927, lat:-27.9402752},
                        {lng:152.9772377, lat:-27.9455829},
                        {lng:152.9743195, lat:-27.9549845},
                        {lng:152.9753494, lat:-27.9625658},
                        {lng:152.9738045, lat:-27.9683272},
                        {lng:152.9743195, lat:-27.9780300},
                        {lng:152.9770660, lat:-27.9840938},
                        {lng:152.9818726, lat:-27.9901572},
                        {lng:153.0113983, lat:-27.9910667},
                        {lng:153.0261612, lat:-27.9886414},
                        {lng:153.0447006, lat:-27.9850033},
                        {lng:153.0505371, lat:-27.9819715},
                        {lng:153.0560303, lat:-27.9783332},
                        {lng:153.0646133, lat:-27.9734819},
                        {lng:153.0721664, lat:-27.9695401},
                        {lng:153.0786896, lat:-27.9680240},
                        {lng:153.0883026, lat:-27.9637787},
                        {lng:153.0951691, lat:-27.9601398},
                        {lng:153.1023788, lat:-27.9586236},
                        {lng:153.1102753, lat:-27.9595333},
                        {lng:153.1161118, lat:-27.9634755},
                        {lng:153.1233215, lat:-27.9640820},
                        {lng:153.1332779, lat:-27.9640820},
                        {lng:153.1398010, lat:-27.9640820},
                        {lng:153.1514740, lat:-27.9625658},
                        {lng:153.1610870, lat:-27.9604431},
                        {lng:153.1734467, lat:-27.9598366},
                        {lng:153.1852913, lat:-27.9605947},
                        {lng:153.1976509, lat:-27.9590784},
                        {lng:153.1998825, lat:-27.9569557},
                        {lng:153.2048607, lat:-27.9555910},
                        {lng:153.2143021, lat:-27.9539231},
                        {lng:153.2194519, lat:-27.9533165},
                        {lng:153.2314682, lat:-27.9446731},
                        {lng:153.2409096, lat:-27.9379625},
                        {lng:153.2440853, lat:-27.9372801},
                        {lng:153.2475185, lat:-27.9378488},
                        {lng:153.2485914, lat:-27.9382279},
                        {lng:153.2494068, lat:-27.9389862},
                        {lng:153.2501793, lat:-27.9398203},
                        {lng:153.2511234, lat:-27.9394412},
                        {lng:153.2514668, lat:-27.9400857},
                        {lng:153.2525396, lat:-27.9403511},
                        {lng:153.2548141, lat:-27.9417918},
                        {lng:153.2709503, lat:-27.9423984},
                        {lng:153.2745552, lat:-27.9627174},
                        {lng:153.2817650, lat:-27.9930372},
                        {lng:153.2944679, lat:-28.0310765},
                        {lng:153.3341217, lat:-28.0928807},
                        {lng:153.4461737, lat:-28.1843475},
                        {lng:153.4486628, lat:-28.1834775},
                        {lng:153.4490061, lat:-28.1829858},
                        {lng:153.4506369, lat:-28.1818888},
                        {lng:153.4528685, lat:-28.1811322},
                        {lng:153.4553576, lat:-28.1812457},
                        {lng:153.4571171, lat:-28.1804513},
                        {lng:153.4575033, lat:-28.1795056},
                        {lng:153.4591770, lat:-28.1781059},
                        {lng:153.4587479, lat:-28.1750795},
                        {lng:153.4609312, lat:-28.1724905},
                        {lng:153.4616983, lat:-28.1712491},
                        {lng:153.4620845, lat:-28.1710505},
                        {lng:153.4630448, lat:-28.1699558},
                        {lng:153.4630823, lat:-28.1697642},
                        {lng:153.4650028, lat:-28.1676172},
                        {lng:153.4656894, lat:-28.1660424},
                        {lng:153.4660274, lat:-28.1657350},
                        {lng:153.4666497, lat:-28.1646142},
                        {lng:153.4685004, lat:-28.1625191},
                        {lng:153.4707749, lat:-28.1617908},
                        {lng:153.4724593, lat:-28.1619422},
                        {lng:153.4737468, lat:-28.1607693},
                        {lng:153.4736609, lat:-28.1601734},
                        {lng:153.4744334, lat:-28.1597950},
                        {lng:153.4749296, lat:-28.1581302},
                        {lng:153.4769306, lat:-28.1570188},
                        {lng:153.4773999, lat:-28.1570732},
                        {lng:153.4787250, lat:-28.1575887},
                        {lng:153.4805703, lat:-28.1575083},
                        {lng:153.4812462, lat:-28.1578039},
                        {lng:153.4814876, lat:-28.1583714},
                        {lng:153.4826088, lat:-28.1584282},
                        {lng:153.4829119, lat:-28.1582177},
                        {lng:153.4850362, lat:-28.1577400},
                        {lng:153.4858274, lat:-28.1570519},
                        {lng:153.5276806, lat:-28.1738453},
                        {lng:153.5277262, lat:-28.1739470},
                        {lng:153.5278764, lat:-28.1740108},
                        {lng:153.5279462, lat:-28.1739588},
                        {lng:153.5311648, lat:-28.1752474},
                        {lng:153.5311487, lat:-28.1757439},
                        {lng:153.5321707, lat:-28.1761671},
                        {lng:153.5340616, lat:-28.1769356},
                        {lng:153.5346437, lat:-28.1776141},
                        {lng:153.5356200, lat:-28.1759969},
                        {lng:153.5366607, lat:-28.1749660},
                        {lng:153.5396004, lat:-28.1720152},
                        {lng:153.5414886, lat:-28.1690265},
                        {lng:153.5507584, lat:-28.1650162},
                    ];

                    if (targetRegion == 'none' || targetRegion == 'qld') {
                        const qld = new google.maps.Polygon({
                            paths: qldCoords,
                            strokeColor: "#003B59",
                            strokeOpacity: 0.8,
                            strokeWeight: 2,
                            fillColor: "#003B59",
                            fillOpacity: 0.35,
                        });
                        qld.setMap(map_obj);
                        if (targetRegion != 'qld') {
                            qld.addListener('click', function () {
                                location.href="/qld";
                            });
                        }
                    }
                }

                let $postcodeSearch = $mapHolder.find('.js-postcode-search');
                if($postcodeSearch.length){
                    let postcodeMarker = null;
                    let apiLoading = false;

                    $postcodeSearch.find('input[name="postcode"]').on('change', function(){
                        if(!apiLoading){
                            lookupPostcode();
                        }
                    });
                    
                    $postcodeSearch.find('.js-postcode-search-button').on('click', function(){
                        if(!apiLoading){
                            lookupPostcode();
                        }
                    });

                    function lookupPostcode(){
                        let postcode = $postcodeSearch.find('input[name="postcode"]').val();
                        if(postcode == ''){
                            map_obj.setCenter({
                                lat: lat,
                                lng: lng
                            });
                            map_obj.setZoom(zoom);
                        }else{
                            apiLoading = true;
                            var geocoder = new google.maps.Geocoder();
                            geocoder.geocode( {'address': postcode+' '+$postcodeSearch.data('state')+' Australia'}, function(results, status) {
                                apiLoading = false;
                                if(status == google.maps.GeocoderStatus.OK && results.length){
                                    if(results[0].formatted_address == "Queensland, Australia"){
                                        $.oc.flashMsg({
                                            'text': "We couldn't find the postcode/suburb you entered.",
                                            'class': 'error',
                                            'interval': 3
                                        });
                                    }else{
                                        map_obj.setCenter({
                                            lat: results[0].geometry.location.lat(),
                                            lng: results[0].geometry.location.lng()
                                        });
                                        if(postcodeMarker != null){
                                            postcodeMarker.setMap(null);
                                        }
                                        postcodeMarker = new google.maps.Marker({
                                            position: {
                                                "lat": results[0].geometry.location.lat(),
                                                "lng": results[0].geometry.location.lng()
                                            },
                                            map: map_obj,
                                            icon: pin,
                                        });
                                        map_obj.setZoom(14);
                                    }
                                }else{
                                    $.oc.flashMsg({
                                        'text': "We couldn't find the postcode/suburb you entered.",
                                        'class': 'error',
                                        'interval': 3
                                    });
                                }
                            });
                        }
                    }
                }

                let $expandable = $mapHolder.find('.js-map-expandable');
                if($expandable.length){
                    $expandable.find('.js-map-expand-toggle').on('click', function(){
                        $expandable.toggleClass('active');
                    });
                }
            });

            window.addLocationsToMapGlobal = function(center, locations, houseLandClickFunction = false){
                if(center !== undefined && center !== null && center !== ''){
                    ajaxMap.setCenter(JSON.parse(center))
                }
                
                for (let i = 0; i < ajaxPoints.length; i++) {
                    ajaxPoints[i].setMap(null);
                }
                
                let points = [];
                addLocationsToMap(ajaxMap, ajaxPin, ajaxActivePin, JSON.parse(locations), points, true, houseLandClickFunction);
                ajaxPoints = points;
            }

            function addLocationsToMap(map, pin, activePin, locations, points, hasClickFunction, houseLandClickFunction = false) {
                let i = 0;
                locations.forEach((item) => {
                    if (item.lat && item.lng) {
                        points[i] = new google.maps.Marker({
                            position: {
                                "lat": parseFloat(item.lat),
                                "lng": parseFloat(item.lng)
                            },
                            map: map,
                            icon: pin,
                        });
                        points[i]['id'] = item.id;
                        if(houseLandClickFunction){
                            google.maps.event.clearInstanceListeners(points[i]);
                            points[i].addListener('click', function () {
                                points.forEach((item) => {
                                    if(item.id == this.id){
                                        item.setIcon(activePin);
                                    }else{
                                        item.setIcon(pin);
                                    }
                                });
                                let latLng = this.getPosition();
                                map.setCenter(latLng);
                                map.setZoom(10);
                                let $filtersForm = $('.js-filters-form');
                                let $mapForm = $('.js-map-form');
                                let filters = [];
                                $.each($filtersForm.serializeArray(), function() {
                                    if(this.name.includes('[]')){
                                        if(filters[ this.name ] === undefined){
                                            filters[ this.name ] = [ this.value ];
                                        }else{
                                            filters[ this.name ].push(this.value);
                                        }
                                    }else{
                                        filters[ this.name ] = this.value;
                                    }
                                });
                                console.log(filters);
                                $mapForm.find('input').each(function(){
                                    if(filters[$(this).attr('name')] !== undefined){
                                        $(this).val(filters[$(this).attr('name')]);
                                    }
                                });
                                $mapForm.find('[name="id"]').val(item.id);
                                $mapForm.find('[name="estate_id"]').val(item.estate_id);
                                $mapForm.find('[name="suburb_nsw_id"]').val(item.suburb_nsw_id);
                                $mapForm.find('.ajax-submit').trigger('click');
                            });
                        }else if(hasClickFunction){
                            google.maps.event.clearInstanceListeners(points[i]);
                            points[i].addListener('click', function () {
                                points.forEach((item) => {
                                    if(item.id == this.id){
                                        item.setIcon(activePin);
                                    }else{
                                        item.setIcon(pin);
                                    }
                                });
                                let latLng = this.getPosition();
                                map.setCenter(latLng);
                                map.setZoom(10);
                                let $listings = $('.js-map-location');
                                let $listingHolders = $('.js-map-location-holder');
                                let $listingsMobile = $('.js-map-mobile-location');
                                $listings.removeClass('active highlight');
                                $listingHolders.removeClass('active');
                                $listingsMobile.removeClass('active');
                                let $listing = $listings.filter('[data-id="'+item.id+'"]');
                                let $listingMobile = $listingsMobile.filter('[data-id="'+item.id+'"]');
                                $listing.addClass('active');
                                $listingMobile.addClass('active');
                                $listing.parents('.js-map-location-holder').addClass('active');
                                let $parent = $listing.parents('.js-map-locations-holder')
                                $parent.animate({
                                    scrollTop: $parent.scrollTop() + $listing.position().top,
                                    scrollLeft: $parent.scrollLeft() + $listing.position().left
                                }, 100);
                            });
                        }
                        i++;
                    }
                });
                
                $('.js-map-location').off('click');
                $('.js-map-location').on('click', function(){
                    let $listing = $(this);
                    let $listings = $('.js-map-location');
                    $listings.removeClass('highlight');
                    $listing.addClass('highlight');
                    points.forEach((item) => {
                        if(item.id == $listing.data('id')){
                            let latLng = item.getPosition();
                            map.setCenter(latLng);
                            map.setZoom(10);
                        }
                    });
                });
                if(window.ontouchstart === undefined){
                    $('.js-map-location').off('mouseenter mouseleave');
                    $('.js-map-location').on('mouseenter', function(){
                        let $listing = $(this);
                        let $listings = $('.js-map-location');
                        let $listingHolders = $('.js-map-location-holder');
                        let $listingsMobile = $('.js-map-mobile-location');
                        $listings.removeClass('active highlight');
                        $listingsMobile.removeClass('active');
                        $listingHolders.removeClass('active')
                        $listing.addClass('active')
                        $listingsMobile.filter('[data-id="'+$listing.data('id')+'"]').addClass('active')
                        $listing.parents('.js-map-location-holder').addClass('active');
                        points.forEach((item) => {
                            if(item.id == $listing.data('id')){
                                item.setIcon(activePin);
                            }else{
                                item.setIcon(pin);
                            }
                        });
                    });
                }
                $('.js-map-location').on('mouseleave', function(){
                    let $listing = $(this);
                    let $listings = $('.js-map-location');
                    $listings.removeClass('active highlight');
                    points.forEach((item) => {
                        if(item.id == $listing.data('id')){
                            item.setIcon(pin);
                        }
                    });
                });
            }

            window.scrollToResultsSingle = function(){
                $([document.documentElement, document.body]).animate({
                    scrollTop: $('#results-single').offset().top
                }, 200);
            }
        });
    };

    return {
        init: init
    };
};

export default GMap;